// extracted by mini-css-extract-plugin
export default {"header":"navigation_header__OJHC1","school_results":"navigation_school_results__Vql1z"};